import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import { local } from 'embroider-css-modules';
import type { MenuItem } from 'frontend-payments/components/navigation/header';

import styles from './tab-navigation.module.css';

interface NavigationTabsTabNavigationSignature {
  Args: {
    item: MenuItem;
  };
}

const NavigationTabsTabNavigation = <template>
  <li class={{local styles "list-item" (if @item.active "active")}}>
    <LinkTo @activeClass="" @route={{@item.route}} class={{styles.link}}>
      <span class="flex items-center">
        {{@item.label}}
      </span>
    </LinkTo>
  </li>
</template> satisfies TOC<NavigationTabsTabNavigationSignature>;

export default NavigationTabsTabNavigation;
